import { Api_Host } from "../api";

export const getAllClaveCDFI = () => Api_Host.get('/clavecdfi/');
